import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <span className="footer-logo">🛡️ EvBackupManager</span>
          <p className="footer-tagline">
            Le module de sauvegarde professionnel pour PrestaShop.<br />
            Développé par <a href="https://technonet.fr" target="_blank" rel="noreferrer">Technonet</a>
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-col">
            <h4>Produit</h4>
            <ul>
              <li><a href="/#features">Fonctionnalités</a></li>
              <li><a href="/#pricing">Tarifs</a></li>
              <li><a href="/#how-to-order">Comment commander</a></li>
              <li><a href="/#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Compte</h4>
            <ul>
              <li><Link to="/login">Connexion</Link></li>
              <li><Link to="/register">Créer un compte</Link></li>
              <li><Link to="/dashboard">Mon espace</Link></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href="mailto:contact@technonet.fr">contact@technonet.fr</a></li>
              <li><span className="text-muted">Support 7j/7 (offres premium)</span></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} Technonet — Tous droits réservés</span>
          <span>EvBackupManager est compatible PrestaShop 1.7+</span>
        </div>
      </div>
    </footer>
  );
}
